module.exports = __webpack_public_path__ + "static/virtual-brain-in-hands-571e220be988667dc19c70b09731cf4f.jpg";